import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=524921ce&scoped=true&"
import script from "./UserModal.vue?vue&type=script&lang=js&"
export * from "./UserModal.vue?vue&type=script&lang=js&"
import style0 from "./UserModal.vue?vue&type=style&index=0&id=524921ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524921ce",
  null
  
)

export default component.exports